import React, { memo, useMemo } from 'react';
import { TableRowBlokProps } from './TableRowBlokProps.interface';
import { storyblokEditable } from 'gatsby-source-storyblok';
import classNames from 'classnames';

interface TableHeaderRowBlokProps extends TableRowBlokProps {
  table_header_row_type: 'accent' | 'default';
}

interface TableHeaderRowProps {
  blok: TableHeaderRowBlokProps;
}

const TableHeaderRow: React.FC<TableHeaderRowProps> = ({ blok }) => {
  const {
    left_side_value,
    right_side_value,
    table_header_row_type,
    table_layout,
  } = blok;

  const leftSideColSpan = useMemo(() => {
    if (!right_side_value) return 4;
    if (table_layout === '25-75') return 1;
    if (table_layout === '50-50') return 2;
    if (table_layout === '75-25') return 3;
  }, [right_side_value, table_layout]);

  const rightSideColSpan = useMemo(() => {
    if (!left_side_value) return 4;
    if (table_layout === '25-75') return 3;
    if (table_layout === '50-50') return 2;
    if (table_layout === '75-25') return 1;
  }, [left_side_value, table_layout]);

  return (
    <tr
      {...storyblokEditable(blok)}
      className={classNames('w-full', {
        'bg-surface/background text-text/body':
          table_header_row_type === 'default',
        'border border-border/default':
          table_header_row_type === 'default' &&
          (!left_side_value || !right_side_value),
        'bg-[#0B212E] text-system/white': table_header_row_type === 'accent',
        'border border-system/white':
          table_header_row_type === 'accent' &&
          (!left_side_value || !right_side_value),
      })}
    >
      {left_side_value && (
        <th
          className={classNames('p-3', {
            'border border-border/default':
              table_header_row_type === 'default' &&
              left_side_value &&
              right_side_value,
            'border border-system/white':
              table_header_row_type === 'accent' &&
              left_side_value &&
              right_side_value,
          })}
          colSpan={leftSideColSpan}
        >
          {left_side_value}
        </th>
      )}
      {right_side_value && (
        <th
          className={classNames('p-3', {
            'border border-border/default':
              table_header_row_type === 'default' &&
              left_side_value &&
              right_side_value,
            'border border-system/white':
              table_header_row_type === 'accent' &&
              left_side_value &&
              right_side_value,
          })}
          colSpan={rightSideColSpan}
        >
          {right_side_value}
        </th>
      )}
    </tr>
  );
};

export default memo(TableHeaderRow);
